import { render, staticRenderFns } from "./TDmanual.vue?vue&type=template&id=7d544352&scoped=true"
import script from "./TDmanual.vue?vue&type=script&lang=js"
export * from "./TDmanual.vue?vue&type=script&lang=js"
import style0 from "./TDmanual.vue?vue&type=style&index=0&id=7d544352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d544352",
  null
  
)

export default component.exports